import {
  ICategoryPageRequestParams,
  useCategoryPageRequestParams,
} from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageRequestParams";
import { logAssert } from "@faire/web/common/logging";
import React, { createContext, useContext, ReactNode } from "react";

export const CategoryPageRequestParamsProvider = ({
  pageNumber,
  children,
}: {
  pageNumber?: number;
  children: ReactNode;
}) => {
  const requestParams = useCategoryPageRequestParams(pageNumber);
  return (
    <CategoryPageRequestParamsContext.Provider value={requestParams}>
      {children}
    </CategoryPageRequestParamsContext.Provider>
  );
};

const CategoryPageRequestParamsContext = createContext<
  ICategoryPageRequestParams | undefined
>(undefined);

export const useCategoryPageRequestParamsContext = () => {
  const data = useContext(CategoryPageRequestParamsContext);
  logAssert(!!data, "Category page request params are undefined");
  return data;
};
